import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * Composable that returns the build/distribution date
 * formatted according to the current locale.
 * 
 * The __BUILD_DATE__ is injected at build time by Vite (see vite.config.js).
 * In dev mode it reflects the server start time; in production it reflects
 * the exact moment the production build was created.
 */
export function useBuildDate() {
  const { locale } = useI18n()

  const buildDate = computed(() => {
    const date = new Date(__BUILD_DATE__)
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    const localeCode = locale.value === 'en' ? 'en-US' : 'de-DE'
    return date.toLocaleDateString(localeCode, options)
  })

  return { buildDate }
}
